import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { attemptService, TestAttemptWithDetails } from '../services/attemptService';
import './TestReviewPage.css'; // Stworzymy ten plik za chwilę

export const TestReviewPage = () => {
  const { attemptId } = useParams<{ attemptId: string }>();
  const [reviewData, setReviewData] = useState<TestAttemptWithDetails | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!attemptId) {
      setError("Nie podano ID próby.");
      setIsLoading(false);
      return;
    }

    const fetchAttemptDetails = async () => {
      try {
        const data = await attemptService.getAttemptWithDetailsById(attemptId);
        if (data) {
          setReviewData(data);
        } else {
          setError("Nie znaleziono takiej próby.");
        }
      } catch (e: any) {
        setError("Wystąpił błąd podczas ładowania danych: " + e.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAttemptDetails();
  }, [attemptId]);
  
  const getAnswerClass = (questionId: string, option: 'A' | 'B' | 'C', correctOptions: Array<'A' | 'B' | 'C'>, userAnswers: Record<string, Array<'A' | 'B' | 'C'>>) => {
    const userSelectedThis = userAnswers[questionId]?.includes(option);
    const isCorrect = correctOptions.includes(option);

    if (userSelectedThis && isCorrect) return 'correct-selected'; // Zaznaczona i poprawna
    if (userSelectedThis && !isCorrect) return 'incorrect-selected'; // Zaznaczona i błędna
    if (!userSelectedThis && isCorrect) return 'missed-correct'; // Niezaznaczona, a poprawna
    return ''; // Zwykła, niezaznaczona, niepoprawna odpowiedź
  };

  if (isLoading) return <div>Ładowanie wyników...</div>;
  if (error) return <div>Błąd: {error}</div>;
  if (!reviewData) return <div>Brak danych do wyświetlenia.</div>;

  const { attempt, testSet, userAnswers } = reviewData;

  return (
    <div className="review-container">
      <h1>Przegląd testu: {testSet.name}</h1>
      <div className="review-summary">
        <p>Data: <strong>{attempt.dateCompleted.toLocaleString('pl-PL')}</strong></p>
        <p>Wynik: <strong>{attempt.score} / {attempt.totalQuestions}</strong></p>
      </div>

      {testSet.questions.map((q, index) => (
        <div key={q.id} className="review-question-card">
          <h4>Pytanie {index + 1}: {q.text}</h4>
          {q.imageUrl && <img src={q.imageUrl} alt="Ilustracja" className="review-question-image" />}
          
          <div className="review-options">
            <div className={getAnswerClass(q.id, 'A', q.correctOptions, userAnswers)}>A: {q.optionA}</div>
            <div className={getAnswerClass(q.id, 'B', q.correctOptions, userAnswers)}>B: {q.optionB}</div>
            <div className={getAnswerClass(q.id, 'C', q.correctOptions, userAnswers)}>C: {q.optionC}</div>
          </div>
        </div>
      ))}
       <Link to="/kursant" className="back-to-dashboard-button">Wróć do panelu</Link>
    </div>
  );
};